import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20stunning%20artistic%20anime-style%20illustration%20of%20a%20dreamy%20library%20filled%20with%20floating%20manga%20books%20and%20cherry%20blossom%20petals%20soft%20pink%20and%20warm%20orange%20gradient%20sky%20magical%20atmosphere%20ethereal%20lighting%20whimsical%20and%20inspiring%20beautiful%20composition%20high%20quality%20illustration&width=1920&height=800&seq=hero-bg-manga&orientation=landscape"
        alt="香香漫画 - 免费漫画在线阅读平台"
        title="香香漫画 | 海量免费漫画"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 via-foreground-950/30 to-foreground-950/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4">
        <h1 className="font-heading text-4xl md:text-6xl text-background-50 text-center mb-4 leading-tight">
          香香漫画
        </h1>
        <p className="text-lg md:text-xl text-background-50/90 text-center mb-2 max-w-2xl">
          香香漫画大全免费 · 香香漫画全集免费 · 香香漫画免费看
        </p>
        <p className="text-sm md:text-base text-background-50/70 text-center mb-8 max-w-xl">
          海量漫画资源，下拉式阅读体验，好看的漫画免费全集追更
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/category"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-base font-medium hover:bg-primary-600 transition-colors no-underline whitespace-nowrap cursor-pointer"
          >
            开始阅读
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/20 text-background-50 rounded-full text-base font-medium hover:bg-background-50/30 backdrop-blur-sm transition-colors no-underline whitespace-nowrap cursor-pointer border border-background-50/30"
          >
            了解更多
          </Link>
        </div>

        <div className="flex items-center gap-8 mt-10">
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl text-accent-500">5000+</p>
            <p className="text-xs text-background-50/70 mt-1">漫画资源</p>
          </div>
          <div className="w-px h-8 bg-background-50/30"></div>
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl text-accent-500">800万+</p>
            <p className="text-xs text-background-50/70 mt-1">注册用户</p>
          </div>
          <div className="w-px h-8 bg-background-50/30"></div>
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl text-accent-500">每日更新</p>
            <p className="text-xs text-background-50/70 mt-1">从不间断</p>
          </div>
        </div>
      </div>
    </section>
  );
}